import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { CommandButton } from "@/components/command-palette/command-button";
import { ButtonColorVariant, ButtonVariant } from "@/components/ui/button";
import { useIsUserSettingsDefault, userConfigStore } from "@/store/user-config-store";
import { useAnimate } from "framer-motion";
import { RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AppearanceSection } from "./_components/appearance-section";
import { AppsSection } from "./_components/apps-section";
import { PhonebookSection } from "./_components/phonebook-section";
import { RegionalSection } from "./_components/regional-section";

export function UserSettingsView() {
  const { t } = useTranslation(["common", "user-settings"]);

  const resetUserSettings = userConfigStore((state) => state.resetUserSettings);
  const isDefault = useIsUserSettingsDefault();
  const [iconRef, animateIcon] = useAnimate();

  async function handleRestoreDefaults() {
    resetUserSettings();
    await animateIcon(iconRef.current, { rotate: -360 }, { duration: 0.4, ease: "easeInOut" });
    animateIcon(iconRef.current, { rotate: 0 }, { duration: 0 });
  }

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Default}
      title={t("user-settings:Settings")}
      subTitle={t("user-settings:ManageYourPersonalSettings")}
    >
      <AppearanceSection />
      <RegionalSection />
      <AppsSection />
      <PhonebookSection />

      <div className="flex justify-end gap-2 pt-2">
        <CommandButton
          commandId="user-settings-restore-defaults"
          label={t("user-settings:RestoreDefaults")}
          icon={<RotateCcw />}
          variant={ButtonVariant.Outlined}
          colorVariant={ButtonColorVariant.Secondary}
          onClick={handleRestoreDefaults}
          disabled={isDefault}
        >
          {t("user-settings:RestoreDefaults")}
          <RotateCcw ref={iconRef} className="h-4 w-4" />
        </CommandButton>
      </div>
    </CenteredLayout>
  );
}
